import { Component } from '@angular/core';

import { ReleaseNotesComponent } from '@olympus/ngx-shared';
import { DialogService } from 'shared-modules-angular/dialog';

import { PcLicenseModalComponent, PcLicenseModalDialogNotification } from '../../../modules/license/components/pc-license.component';
import { ConfigService } from '../../services/config';
import { SystemInfoComponent } from '../system-info/system-info.component';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  standalone: false,
})
export class HelpMenuComponent {
  public licenseType: string | null;

  constructor(
    private readonly _dialogService: DialogService,
    private readonly _configService: ConfigService,
  ) {
    this.licenseType = this._configService.licenseType;
  }

  public openSystemInfoModal(): void {
    this._dialogService.open(
      SystemInfoComponent,
      {
        height: SystemInfoComponent.HEIGHT,
        width: SystemInfoComponent.WIDTH,
        disableClose: true,
      },
    );
  }

  public openReleaseNotesModal(): void {
    this._dialogService.open(
      ReleaseNotesComponent,
      {
        height: ReleaseNotesComponent.HEIGHT,
        width: ReleaseNotesComponent.WIDTH,
        disableClose: true,
      },
    );
  }

  public openLicenseModal(): void {
    const notification: PcLicenseModalDialogNotification = { licenseStatus: undefined, promptRestartOnLicenseChange: true };
    this._dialogService.open(
      PcLicenseModalComponent,
      {
        data: notification,
        height: PcLicenseModalComponent.HEIGHT,
        width: PcLicenseModalComponent.WIDTH,
        disableClose: true,
      },
    );
  }
}
